import { Button } from '@/components/ui/button';
import { Download } from 'lucide-react';
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from '@/components/ui/tooltip';

export default function DownloadButton({
  projectId,
  uploadId,
  status,
  handleDownload,
}: {
  projectId: string;
  uploadId: string;
  status: string;
  handleDownload: (projectId: string, uploadId: string) => Promise<void>;
}) {
  return (
    <Tooltip delayDuration={800}>
      <TooltipTrigger asChild>
        <Button
          size={'icon-sm'}
          variant={'ghost'}
          onClick={() => handleDownload(projectId, uploadId)}
          className="cursor-pointer"
          disabled={status !== 'attached'}
        >
          <Download />
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        <p>Download file</p>
      </TooltipContent>
    </Tooltip>
  );
}
